module.exports = __webpack_public_path__ + "93ccdc3dce069319230be02b8dd95d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/App/screens/Orders/screens/Confirmation/images/confirmacionCompraLimpieza.png
// module id = 1469
// module chunks = 0